import styled from '@emotion/styled';
import { primaryFontFamily } from '../../../styles/fonts';

export const Container = styled.div`
  ${primaryFontFamily}
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${({ theme }) => theme.default.colors.n5};
  cursor: ${({ onClick }) =>
    typeof onClick !== 'undefined' ? 'pointer' : 'default'};
`;

export const Date = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.default.colors.n3};
`;
